import gql from 'graphql-tag';

export const UPDATED_RECEIPT_STATUS = gql`
  subscription updatedReceiptStatus($tenant_id: Int!) {
    updatedReceiptStatus(tenant_id: $tenant_id) {
      __typename
      ... on SubscriptionReceiptHeaderResponse {
        tenant_id
        receipt_header_id
        context
        status_id
      }
      ... on ResultErrorByTenant {
      tenant_id
      status_code
      message
      message_translation_key
      }
    }
  }
`;
